<script>
    import Icon from './icon.svelte'

    let audio=null, audio_scr='demo.mp3', paused = true, vol=1, time=0, duration=0, filename=audio_scr;

    function CalculateTime(secs) {
        const minutes = Math.floor(secs / 60);
        const seconds = Math.floor(secs % 60);
        const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
        return `${minutes}:${returnedSeconds}`;
    }

    function Load(e){
        if (!e.target.files.length) return;
        audio_scr = URL.createObjectURL(e.target.files[0]);
        // console.log(e.target.files[0])
        filename = e.target.files[0].name
    }
</script>

<section>
    <div class="horiz">
        <audio src={audio_scr} preload="auto" loop bind:this={audio} bind:paused={paused} bind:volume={vol} bind:currentTime={time} bind:duration={duration}></audio>
        <button on:click={() => paused = !paused} title="Play/Pause"><Icon>{paused ? 'play_arrow' : 'pause'}</Icon></button>
        <label title="Load your song"><Icon>upload_file</Icon><input type="file" accept="audio/*" on:change={Load}></label>
        <Icon>volume_up</Icon>
        <input class="vol" type="range" min="0" max="1" step="0.01" bind:value={vol}>
        <h3 style="font-size: 14px;">{filename}</h3>
    </div>

    <div class="horiz time" title="Playback timeline">
        <Icon>audiotrack</Icon>
        <input type="range" min="0" max={Math.ceil(duration)} step="0.01" bind:value={time} class="time">
        <h3 class="timer">{CalculateTime(time)}/{CalculateTime(duration)}</h3>
    </div>
</section>

<style lang="scss">
    audio{
        @include hide;
    }
    section{
        width: 100%;
        min-height: 42px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;

        h3{
            @include text;
            font-size: 18px;
        }
    }

    button, label{
        @include button;

        input{
            @include hide;
        }
    }

    span{
        @include icon;
        pointer-events: none;
    }

    .horiz{
        width: 100%;
        display: flex;
        justify-content: left;
        align-items: center;
        gap: 6px;
    }

    .vol{
        width: 120px;
    }

    .time{
        flex-grow: 1;
    }

    .space{
        margin-right: 6px;
    }
</style>